module.exports = __webpack_public_path__ + "static/logo-universal-4ee0b5e18395b2d7e69e444214b45e41.svg";